import { CurrencyPipe, DecimalPipe, PercentPipe, ViewportScroller } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { ServiceAppService } from '../../../../security/service-app.service';
import { ConversaoLibraConverte } from "../../../../shared/conversao-libra/conversao-libra-converte";
import { ExportExcelService } from "../../../../shared/excel-service/export-excel.service";

@Component({
  selector: "app-primeng-teste-lista",
  templateUrl: "./primeng-teste-lista.component.html",
  styleUrls: ["./primeng-teste-lista.component.scss"],
})
export class PrimengTesteListaComponent implements OnInit {

  first = 0;
  rows = 10;
  cols: any[]
  _selectedColumns: any[];
  _selectedColumnsAnalit: any[];
  analyticalColumns: Array<any>
  progress: boolean;
  loading: boolean;
  syntheticData: any[]
  analyticalData = []
  total: any[]

  _selectedColumnsTitle: any[];

  // principal = [
  //   { header: "PCA-CONSOLIDADO", colspan: 2, text: 'center' },
  //   { header: "Ano", colspan: 5, text: 'center' },
  // ];

  dadosTranslate = {
    Brasil: "commercial.commercialVarejo.abaPrincipal.brasil",
    "PCA-CONSOLIDADO":
      "commercial.commercialVarejo.abaPrincipal.tituloPcaConsolidado",
    PEÇAS: "commercial.commercialVarejo.abaPrincipal.tituloPecas",
    ROUPAS: "commercial.commercialVarejo.abaPrincipal.tituloRoupas",
    ACESSÓRIOS: "commercial.commercialVarejo.abaPrincipal.tituloAcessorios",
    "Calculando...": "commercial.commercialVarejo.calculando",
  };

  subscription;

  exportColumns: any[];

  constructor(
    private service: ServiceAppService,
    private viewportScroller: ViewportScroller,
    private exportExcel: ExportExcelService,
    private cdRef: ChangeDetectorRef,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private currency: CurrencyPipe,
    private percent: PercentPipe,
    private number: DecimalPipe
  ) { }

  ngOnInit(): void {
    this.retornaDados();

    this.cols = [
      { field: 'dealerCode', header: 'Cód. Dealer', width: '100px', class: "row-float" },
      { field: 'dealerName', header: 'Nome Dealer', width: '100px' },
      // { field: 'errorsQuantity', header: 'Qtd. Bloqueados', width: '140px' },
      // { field: 'interfaceQuantity', header: 'Budget YTD', width: '140px' },
      { field: 'errorsQuantity', header: 'Bloqueados', width: '140px' },
      // { field: 'pendentefull', header: 'Pendente Full', width: '140px' },
      // { field: 'pendenteytd', header: 'Pendente YTD', width: '140px' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    this._selectedColumns = this.cols;

    this.columns();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  columns() {
    this.analyticalColumns = [
      { field: 'dealerCode', header: 'Cód. Dealer' },
      { field: 'serviceType', header:'Operação' },
      { field: 'description', header: 'Envio' },
      { field: 'message', header: 'Mensagem' },
      { field: 'osClosingDate', header:'Ultima comunicação' },
      
    ];

    this._selectedColumnsAnalit = this.analyticalColumns;
  }

  @Input() get selectedColumnsAnalit(): any[] {
    return this._selectedColumnsAnalit;
  }

  set selectedColumnsAnalit(val: any[]) {
    this._selectedColumnsAnalit = this.analyticalColumns.filter(col => val.includes(col));
  }

  retornaDados() {
    this.loading = true
    //this.service.getPadrao('commercial.json').then(dados => {
    this.service.getDados('/status_operacao').subscribe(dados => {
      this.syntheticData = dados.dados;

      // this.total = [
      //   { value: '' },
      //   { value: 'Brasil' },
      //   { value: dados.total.totalbudgetfull },
      //   { value: dados.total.totalbudgetytd },
      //   { value: dados.total.totalpendentefull },
      //   { value: dados.total.totalpendenteytd },
      //   { value: dados.total.totalrealizado },
      // ]
      this.loading = false
    });
    this.analyticalData = [];
  }

  retornaDadosAnalytical(dealerCode) {
    this.loading = true;
      this.service.getDados('/status_operacao/analitico/' + dealerCode).subscribe(dados => {

      this.analyticalData = dados.dados;

      this.loading = false;
    });
    setTimeout(() => { this.viewportScroller.scrollToAnchor('target'); }, 400);
  }

  // isLastPage(): boolean {
  //   return this.syntheticData ? this.first === (this.syntheticData.length - this.rows) : true;
  // }

  // isFirstPage(): boolean {
  //   return this.syntheticData ? this.first === 0 : true;
  // }



}